import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import CenterTop from '@/components/layout/CenterTop.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import PlatformPreview from '@/components/platform/PlatformPreview.vue';
import GridLayout from '@/components/layout/GridLayout.vue';
import GridItem from '@/components/layout/GridItem.vue';
import Card from '@/components/layout/Card.vue';
import { PLATFORM_SUMMARY, SEARCH_PLATFORMS } from '@/store/actions/platforms';
import store from '@/store';
import TotalSummaries from '@/components/platform/TotalSummaries.vue';
import PlatformsTable from '@/components/platform/PlatformsTable.vue';
import { HOME_PAGE_SIMPLE_VIEW } from '@/store/actions/configurations';
import WStandardButton from '@/components/wrapper/w-standard-button.vue';
import { PlatformsSortEnum } from "@/store/enums/PlatformsSortEnum";
import { SortOrderEnum } from "@/store/enums/SortOrderEnum";
import AddPlatform from "@/views/enroll/AddPlatform.vue";
import CreatePlatform from "@/views/platform/CreatePlatform.vue";
import debounce from "lodash/debounce";
import { v4 as uuidv4 } from "uuid";
import StandardNotificationDialog from "@/components/dialog/StandardNotificationDialog.vue";
import MessagesUtil from '@/utils/messagesUtil';
import InfiniteLoading from 'vue-infinite-loading';
var HomeView = /*#__PURE__*/function (_Vue) {
  function HomeView() {
    var _this;
    _classCallCheck(this, HomeView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HomeView, [].concat(args));
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "pfLoading", {});
    _defineProperty(_this, "pfErrorMsg", {});
    _defineProperty(_this, "pageSize", 51);
    _defineProperty(_this, "currentPlatformSearchValue", void 0);
    _defineProperty(_this, "currentSortBy", PlatformsSortEnum.NAME);
    _defineProperty(_this, "currentSortOrder", SortOrderEnum.ASC);
    _defineProperty(_this, "toggleConnectPlatformDialog", false);
    _defineProperty(_this, "togglePlatformCreationDialog", false);
    _defineProperty(_this, "togglePlatformConnectionSuggestDialog", false);
    _defineProperty(_this, "infiniteLoaderID", uuidv4());
    _defineProperty(_this, "debounceInfinite", debounce(function (state) {
      _this.searchPlatforms(_this.platformsCurrentPage + 1, state, true);
    }, 250));
    return _this;
  }
  _inherits(HomeView, _Vue);
  return _createClass(HomeView, [{
    key: "mounted",
    value: function mounted() {
      this.checkNewEnrolledPlatform();
      this.listPlatforms();
    }
  }, {
    key: "isPlatformConnect",
    get: function get() {
      return store.getters.isPlatformConnectAvailable;
    }
  }, {
    key: "platforms",
    get: function get() {
      return store.getters.platforms;
    }
  }, {
    key: "platformsCurrentPage",
    get: function get() {
      return store.getters.platformsCurrentPage;
    }
  }, {
    key: "totalNumberPlatforms",
    get: function get() {
      return store.getters.totalNumberPlatforms;
    }
  }, {
    key: "totalPlatformsOnCurrentPage",
    get: function get() {
      return store.getters.totalPlatformsOnCurrentPage;
    }
  }, {
    key: "summaries",
    get: function get() {
      return store.getters.summaries;
    }
  }, {
    key: "isPlatformCreator",
    get: function get() {
      return store.getters.isPlatformCreatorAvailable;
    }
  }, {
    key: "checkNewEnrolledPlatform",
    value: function checkNewEnrolledPlatform() {
      var _this$$route$query;
      var newEnrolledPlatform = (_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 || (_this$$route$query = _this$$route$query.enrolledPlatform) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.toString();
      if (newEnrolledPlatform) {
        MessagesUtil.showSuccessMessage(this.$t('home.platform_connected_toast.message', {
          platformUrl: newEnrolledPlatform
        }).toString(), 3000);
        window.history.replaceState(null, null, this.$route.path); // remove query args from url
      }
    }
  }, {
    key: "listPlatforms",
    value: function listPlatforms() {
      var _this2 = this;
      this.resetErrorMsg();
      store.dispatch(SEARCH_PLATFORMS, this.buildPlatformsSearchCriteria(0)).then(function () {
        if (_this2.shouldSuggestPlatformConnection()) {
          _this2.togglePlatformConnectionSuggestDialog = true;
        } else {
          _this2.listSummary();
        }
      }).catch(function (err) {
        _this2.setErrorMsg(err);
      });
    }
  }, {
    key: "shouldSuggestPlatformConnection",
    value: function shouldSuggestPlatformConnection() {
      return Object.values(this.platforms).length === 0 && this.isPlatformConnect;
    }
  }, {
    key: "setErrorMsg",
    value: function setErrorMsg(errorMsg) {
      this.errorMsg = errorMsg;
    }
  }, {
    key: "resetErrorMsg",
    value: function resetErrorMsg() {
      this.errorMsg = '';
    }
  }, {
    key: "isHomepageSimpleview",
    get: function get() {
      return store.getters.isHomepageSimpleview;
    }
  }, {
    key: "toggleSimpleView",
    value: function toggleSimpleView() {
      store.dispatch(HOME_PAGE_SIMPLE_VIEW, !store.getters.isHomepageSimpleview);
    }
  }, {
    key: "listSummary",
    value: function () {
      var _listSummary = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(append) {
        var _this3 = this;
        var _i, _Object$values, platform, _loop, _i2, _Object$values2;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (append) {
                _context2.next = 11;
                break;
              }
              _i = 0, _Object$values = Object.values(this.platforms);
            case 2:
              if (!(_i < _Object$values.length)) {
                _context2.next = 9;
                break;
              }
              platform = _Object$values[_i];
              _context2.next = 6;
              return this.summary(platform);
            case 6:
              _i++;
              _context2.next = 2;
              break;
            case 9:
              _context2.next = 18;
              break;
            case 11:
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var p, platform, platformSummaryDontExist;
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      p = _Object$values2[_i2];
                      platform = p;
                      platformSummaryDontExist = !Object.entries(_this3.summaries).filter(function (entry) {
                        return entry[0] === platform.platformID;
                      })[0];
                      if (!platformSummaryDontExist) {
                        _context.next = 6;
                        break;
                      }
                      _context.next = 6;
                      return _this3.summary(platform);
                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _i2 = 0, _Object$values2 = Object.values(this.platforms);
            case 13:
              if (!(_i2 < _Object$values2.length)) {
                _context2.next = 18;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 15);
            case 15:
              _i2++;
              _context2.next = 13;
              break;
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function listSummary(_x) {
        return _listSummary.apply(this, arguments);
      }
      return listSummary;
    }()
  }, {
    key: "summary",
    value: function () {
      var _summary = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(platform) {
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.pfErrorMsg[platform.platformID] = '';
              _context3.prev = 1;
              _context3.next = 4;
              return store.dispatch(PLATFORM_SUMMARY, platform);
            case 4:
              this.pfLoading[platform.platformID] = false;
              this.pfErrorMsg[platform.platformID] = '';
              _context3.next = 12;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              this.pfLoading[platform.platformID] = false;
              this.pfErrorMsg[platform.platformID] = _context3.t0;
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this, [[1, 8]]);
      }));
      function summary(_x2) {
        return _summary.apply(this, arguments);
      }
      return summary;
    }()
  }, {
    key: "onSearchInputUpdate",
    value: function onSearchInputUpdate(searchValue) {
      this.resetInfiniteHandler();
      this.currentPlatformSearchValue = searchValue;
      this.searchPlatforms(0);
    }
  }, {
    key: "onSortChanges",
    value: function onSortChanges(sortData) {
      if (sortData) {
        this.currentSortBy = PlatformsSortEnum[sortData.sortBy];
        this.currentSortOrder = SortOrderEnum[sortData.sortOrder];
        if (this.currentSortBy && this.currentSortOrder) {
          this.resetInfiniteHandler();
          this.searchPlatforms(0);
        }
      }
    }
  }, {
    key: "searchPlatforms",
    value: function searchPlatforms(pageNumber, state, append) {
      var _this4 = this;
      this.resetErrorMsg();
      store.dispatch(SEARCH_PLATFORMS, this.buildPlatformsSearchCriteria(pageNumber, append)).then(function () {
        _this4.listSummary(append);
        if (state) {
          //if we don't append the search, it is a new one, so we have to reset the infinite handler
          if (!append) {
            _this4.resetInfiniteHandler();
          }
          if (_this4.totalNumberPlatforms <= Object.values(_this4.platforms).length || !_this4.totalPlatformsOnCurrentPage) {
            state.complete();
          } else {
            state.loaded();
          }
        }
      }).catch(function (err) {
        _this4.setErrorMsg(err);
        state === null || state === void 0 || state.complete();
      });
    }
  }, {
    key: "buildPlatformsSearchCriteria",
    value: function buildPlatformsSearchCriteria(pageNumber, appendResultInStore) {
      return {
        page: pageNumber,
        pageSize: this.pageSize,
        platformName: this.currentPlatformSearchValue || '',
        sortBy: this.currentSortBy,
        sortOrder: this.currentSortOrder,
        appendResultInStore: appendResultInStore
      };
    }
  }, {
    key: "onUserAcceptToConnectPlatform",
    value: function onUserAcceptToConnectPlatform() {
      this.togglePlatformConnectionSuggestDialog = false;
      this.toggleConnectPlatformDialog = true;
    }
  }, {
    key: "resetInfiniteHandler",
    value:
    //We need to reset the infinite handler when we perform a new search.
    function resetInfiniteHandler() {
      //The easiest way to reset the infinite handler is to change its id
      this.infiniteLoaderID = uuidv4();
    }
  }]);
}(Vue);
HomeView = __decorate([Options({
  components: {
    StandardNotificationDialog: StandardNotificationDialog,
    AddPlatform: AddPlatform,
    CreatePlatform: CreatePlatform,
    WStandardButton: WStandardButton,
    PlatformsTable: PlatformsTable,
    TotalSummaries: TotalSummaries,
    Card: Card,
    GridItem: GridItem,
    GridLayout: GridLayout,
    PlatformPreview: PlatformPreview,
    MainTitle: MainTitle,
    CenterTop: CenterTop,
    InfiniteLoading: InfiniteLoading
  }
})], HomeView);
export default HomeView;